angular.module('bmsApp.employeeUnavailability')
	.controller('EmployeeUnavailabilityCtrl', [
		'$scope',
		'$log',
		'$q',
		'$ngBootbox',
		'notify',
		'EmployeeOptionsSvc',
		'EmployeeUnavailabilitySvc',
		function ($scope,
				  $log,
				  $q,
				  $ngBootbox,
				  notify,
				  EmployeeOptionsSvc,
				  EmployeeUnavailabilitySvc) {

			$scope.formValidator = {};

			function init() {
				self.dateRangeOptions = $scope.config.datePicker.range;
				self.dateRangeOptions.options.format = $scope.config.format.date.amShortDate;
				self.dateRangeOptions.options.opens = 'right';
				delete self.dateRangeOptions.options.ranges;
				EmployeeOptionsSvc.employee()
					.then(function (response) {
						self.options.employee = response.data.options;
					});
			}

			function getEmployeeUnavailability() {
					EmployeeUnavailabilitySvc.read(self.employee.id).then(function(response) {
					self.employee = response.data.employee
					angular.forEach(self.employee.unavailability, function(item) {
						item.start_time = moment(item.start_time, "HH:mm:ss");
						item.end_time = moment(item.end_time, "HH:mm:ss");
					})
				});

			}

			function addRecord() {
				self.employee.unavailability.push({});
			}

			function removeRecord($index, item) {
				if (item.id) {
					angular.extend(item, {
						deleted: true
					});
				}
				else {
					self.employee.unavailability.splice($index,1);
				}
			}

			function addBulkRecords() {
				if (angular.isObject(self.dateRange) && angular.isObject(self.start_time) && angular.isObject(self.end_time)) {
					let startDate = moment(self.dateRange.startDate);
					let endDate = moment(self.dateRange.endDate);

					while (startDate.isSameOrBefore(endDate)) {
						self.employee.unavailability.push({
							date: angular.copy(startDate),
							start_time: moment(angular.copy(startDate.format('YYYY-MM-DD')) + ' ' + self.start_time.format('HH:mm')),
							end_time: moment(angular.copy(startDate.format('YYYY-MM-DD')) + ' ' + self.end_time.format('HH:mm')),
							description: self.description,
						});
						startDate.add(1, 'day');
					}

					self.addBulkRecord = false;
				}
				else {
					notify({
						message: 'You must add a date range, start and end time',
						classes: 'error',
					});
				}
			}

			function submit() {
				if ($scope.formValidator.valid()) {
					$scope.processing = true;
					self.failed = false;
					angular.forEach(self.employee.unavailability, function (record) {
						var start_time, end_time;
						if (angular.isObject(record.start_time)) {
							record.start_time = moment(record.start_time).format("HH:mm:ss");
							start_time = moment(record.start_time, "HH:mm");
						}
						if (angular.isObject(record.end_time)) {
							record.end_time = moment(record.end_time).format("HH:mm:ss");
							end_time = moment(record.end_time, "HH:mm");
						}

						if (angular.isDefined(end_time)) {
							if (end_time.isBefore(start_time)) {
								self.failed = true;
							}
						}

					});

					if (!self.failed) {

						EmployeeUnavailabilitySvc.save(self.employee)
							.then(function (response) {
								notify({
									message: 'Updated'
								});
							});
					}
				}
			}

			var self = $scope.EmployeeUnavailabilityCtrl = {
				processing: false,
				options: {},
				employee: null,
				methods: {
					init: init,
					getEmployeeUnavailability: getEmployeeUnavailability,
					addRecord: addRecord,
					removeRecord: removeRecord,
					addBulkRecords: addBulkRecords,
					submit: submit
				}
			}

		}
	]);
